module.exports = __webpack_public_path__ + "img/loading-02.e88a6077.svg";